export const sendEventToSprig = (eventName: string): void => {
	if (window?.Sprig) {
		window.Sprig('track', eventName)
	}
}
